export default {
    message: {
        impersonation: "Objednáváte jménem «{name}»"
    }
}